import React, { useState, useEffect } from "react";
import { Container, Tab, Row, Col, Nav } from "react-bootstrap";
import Navb from "../../components/navbar/Navb";
import Footer from "../../components/footer/Footer";
import "./Insights.css";
const Insights = () => {
  const [isMenuVisible, setIsMenuVisible] = useState(true);

  // Toggle menu visibility
  const toggleMenu = () => {
    setIsMenuVisible(!isMenuVisible);
  };
  // Content Array to keep the code modular
  const insights = [
    {
      title: "Mobile-Friendly Recruitment Drives",
      content: `In India, statistics say nearly 89% of potential job seekers are stuck in their hometown due to lockdowns and shutdowns (Statistical data survey-People’s Forum, report-2021). HR professionals are now using digital platforms, primarily mobile-based, for recruitments. Candidates can apply, get screened for skills, and be offered employment digitally. With a majority of adults owning Android devices and having easy internet access, mobile-friendly recruitment is bridging the gap between employers and job seekers.`,
    },
    {
      title: "Marketizing Recruitment Strategies",
      content: `According to Cass Bailey, CEO of Slice Communications, "The number of CVs piling up through a job posting reflects who the company is and the growth opportunities it offers." During the pandemic, HR professionals have adopted recruitment marketing as a strategy. By collaborating with marketing teams and sharing employee success stories, companies have been able to attract not only full-time candidates but also freelancers and interns, boosting both brand value and profitability.`,
    },
    {
      title: "Assessment of Resumes",
      content: `The mantra has shifted to "Test the ability, not the words in the resume." Many HR professionals are focusing on cost-effective pre-employment assessments like aptitude tests, business and managerial skills tests, and critical thinking assessments to evaluate candidates effectively.`,
    },
    {
      title: "Health Advocacy Programs",
      content: `Boosting mental flexibility and morale has become the focus of many HR policies in India. Health advocacy programs are now being included in HR policies to support employees, especially those with elderly dependents affected by the pandemic. These programs provide medical advocates to guide employees and liaise with healthcare providers, boosting employee well-being and enhancing the sense of care within the organization.`,
    },
    {
      title: "Care-Giving Benefits",
      content: `Top HR leaders advocate for compensating employees affected by COVID-19 through various care-giving benefits. These include care-giving responsibilities, care assistance to offset costs, remote work options, and paid leave, all of which help boost employee morale during tough times.`,
    },
    {
      title: "Focus on Workplace Practices",
      content: `HR leaders are shifting from a focus on employee engagement to creating a better employee experience. Moving away from a paternalistic approach, HR practices are now more human-centric, encouraging autonomy and diversity. By helping employees find purpose and allowing them to have a say in how, when, and where they work, organizations are creating a more inclusive and empowering work environment.`,
    },
    {
      title: "Separating Critical Skills and Roles",
      content: `The focus has shifted from critical roles to critical skills that are necessary for the organization’s strategic goals. HR professionals are now concentrating on the skills required to drive the organization forward, offering career development and upskilling opportunities to employees to maintain a competitive advantage.`,
    },
    {
      title: "Virtual Team Building",
      content: `With work-from-home (WFH) becoming the norm, traditional team-building activities have been replaced by virtual alternatives. HR professionals are using video call activities, virtual office Olympics, and storytelling competitions to foster team bonding and maintain morale despite physical distances.`,
    },
    {
      title: "Innovative Employee Engagement",
      content: `Employee engagement has evolved beyond traditional methods due to remote work. Innovative strategies such as motivational recitations (e.g., Bhagavad Gita via video conference), quizzing competitions, and virtual food festivals have been introduced to keep employees motivated and engaged, even when working far from the office.`,
    },
    {
      title: "Empathetic Lay-Offs",
      content: `Lay-offs, though inevitable during the pandemic, are being handled empathetically by HR professionals. Virtual meetings, where the company's economic conditions are explained compassionately, have proven successful in helping employees accept their lay-offs. Outplacement support and resources are also provided to assist employees in transitioning to new opportunities.`,
    },
    {
      title: "Hybrid Office",
      content: `The future workplace is hybrid, offering flexibility for employees to work from different locations at different times. As Infosys CEO Salil Parekh mentioned, this model supports inclusivity and business continuity, allowing employees to work from anywhere while maintaining a balance between social capital and productivity.`,
    },
    {
      title: "International Talent Acquisition",
      content: `Global talent acquisition is on the rise, with HR professionals hiring from international talent pools. With countries limiting H-1B visas and employment regulations, companies are turning to cross-border recruitment, benefiting from lower costs and access to skilled professionals willing to work remotely.`,
    },
    {
      title: "Skill Mapping",
      content: `The trend has shifted from job-based HR to skill-based HR. Traditional methods of screening candidates based on resumes and LinkedIn profiles are being replaced by skill intelligence models (SIM). SIM maps out the required and acquired skills, filtering candidates based on their learning potential and adjacent skills rather than industry experience.`,
    },
    {
      title: "Nudge-Not Policy",
      content: `The "Nudge" theory proposes using positive reinforcement and indirect suggestions to influence behavior. In the COVID-19 context, HR leaders are using nudging techniques like "Thank you plates," virtual workstation islands, and displaying ethical leader portraits to promote desirable behaviors like social distancing and mask-wearing in the workplace.`,
    },
    {
      title: "Innovation in Learning & Development",
      content: `Leading companies like Google and Uber are investing heavily in innovative learning and development strategies. Google's "whisper training" involves sending simple suggestions via email to managers, while Uber is using mobile learning platforms to train its vast workforce of drivers across different languages and regions.`,
    },
    {
      title: "No Executionary, Visionary Hiring",
      content: `In a shift from traditional hiring practices, companies like Sun Life ASC, IBM, and KPMG are now seeking candidates with visionary qualities rather than purely cognitive and analytical abilities. This approach focuses on risk-averse candidates who exhibit a blend of strategic thinking and execution capabilities.`,
    },
    {
      title: "Decoding GIG Hiring",
      content: `There has been a sharp increase in hiring gig workers, with the ratio of gig workers rising to 1 in 4 during the pandemic. This trend reflects the growing need for flexibility in the workforce and the increasing reliance on remote workers to fill short-term roles.`,
    },
  ];
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth < 700) {
        setIsMenuVisible(false); // Hide menu for small screens
      } else {
        setIsMenuVisible(true); // Show menu for larger screens
      }
    };

    // Check screen size on initial load
    handleResize();

    // Add event listener to handle screen resize
    window.addEventListener("resize", handleResize);

    // Clean up the event listener
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  
  useEffect(() => {
    const sections = document.querySelectorAll(".insight-section");
    const menuLinks = document.querySelectorAll(".insights-menu a");

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            menuLinks.forEach((link) => link.classList.remove("active"));
            const activeLink = document.querySelector(
              `a[href="#${entry.target.id}"]`
            );
            activeLink?.classList.add("active");
          }
        });
      },
      { threshold: 0.5 }
    );

    sections.forEach((section) => observer.observe(section));

    return () => observer.disconnect();
  }, []);

  return (
    <>
      <Navb />

      <div className="insights-container">
    
        <div className="menu-toggle">
          <button onClick={toggleMenu}>{isMenuVisible ? "<" : ">"}</button>
        </div>
        <div className={`insights-menu ${isMenuVisible ? "" : "hidden"}`}>
          <div className="menu-toggle">
          </div>
          <ul>
            {insights.map((insight, index) => (
              <li key={index}>
                <a href={`#insight-${index}`}>{insight.title}</a>
              </li>
            ))}
          </ul>
        </div>
        <div className="insights-content">
          {insights.map((insight, index) => (
            <section
              id={`insight-${index}`}
              className="insight-section"
              key={index}
            >
              <h2 className="Heading43">{insight.title}</h2>
              <p style={{ fontSize: "18px", lineHeight: "45px" }}>
                {insight.content}
              </p>
            </section>
          ))}
        </div>
      </div>

      <Footer />
    </>
  );
};
export default Insights;
